import React from "react"
import "./EtapasProyecto.scss"

// Orden fijo de las etapas. La taxonomía "estados" de WordPress no tiene
// orden propio, así que la secuencia se define aquí. El match con el
// proyecto se hace por SLUG del estado (más estable que el nombre).
const ETAPAS = [
  { slug: "pre-lanzamiento", label: "Pre lanzamiento" },
  { slug: "lanzamiento", label: "Lanzamiento" },
  { slug: "preventa", label: "Preventa" },
  { slug: "proximo-inicio-de-obra", label: "Próximo Inicio de obra" },
  { slug: "construccion", label: "Construcción" },
  { slug: "proxima-entrega", label: "Próxima entrega" },
  { slug: "entrega-inmediata", label: "Entrega Inmediata" },
]

const EtapasProyecto = ({ estadoSlug }) => {
  const total = ETAPAS.length
  const activeIndex = ETAPAS.findIndex(e => e.slug === estadoSlug)

  // Media casilla a cada lado, para alinear la línea con el centro de los círculos.
  const inset = 50 / total
  const progressWidth = activeIndex > 0 ? (activeIndex / total) * 100 : 0

  return (
    <section className="etapas-seccion bg-negro">
      <div className="etapas-contenido mwx-1680 mx-auto">
        <h2 className="etapas-titulo font-roboto weight-300 text-center color-blanco">
          <span className="weight-bold">Etapas</span> del proyecto
        </h2>
        <div className="etapas-track">
          <div
            className="etapas-inner"
            style={{ "--etapas-inset": `${inset}%` }}
          >
            <div className="etapas-line-wrap">
              <span className="etapas-line" />
              <span
                className="etapas-line-progreso"
                style={{ width: `${progressWidth}%` }}
              />
            </div>
            <ul className="etapas-lista">
              {ETAPAS.map((etapa, i) => {
                const isDone = activeIndex >= 0 && i <= activeIndex
                const isCurrent = i === activeIndex
                return (
                  <li
                    key={etapa.slug}
                    className={`etapas-item ${isDone ? "is-done" : ""} ${
                      isCurrent ? "is-current" : ""
                    }`}
                  >
                    <span className="etapas-num font-roboto">{i + 1}</span>
                    <span className="etapas-label font-lato">{etapa.label}</span>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EtapasProyecto
